import { render, staticRenderFns } from "./bankStatementTab.vue?vue&type=template&id=9603e5a0&scoped=true&lang=pug"
import script from "./bankStatementTab.vue?vue&type=script&lang=js"
export * from "./bankStatementTab.vue?vue&type=script&lang=js"
import style0 from "./bankStatementTab.vue?vue&type=style&index=0&id=9603e5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9603e5a0",
  null
  
)

export default component.exports